import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useEffect, useMemo} from "react";
import {Control, FieldError} from "react-hook-form";
import {getAutocompleteSchedules} from "../../common/util/helpers";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../../authentication/redux";
import {ForwardToNumberField} from "../../common/components/ForwardToNumberField";
import {usePhoneNumbersToForwardTo} from "../../common/servercall/usePhoneNumbersToForwardTo";
import {UseFormSetValue} from "react-hook-form/dist/types/form";

type Props = {
    index: number
    control: Control<any>
    openingHours: boolean
    setValue: UseFormSetValue<any>
    error?: FieldError
    invalid?: boolean
}


export const ForwardingScheduleForm = ({ index, control, openingHours, setValue }: Props) => {
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    const scheduleOptions = useMemo(() => {
        return getAutocompleteSchedules(t, openingHours? 'opening-hours': 'holidays', site, null)
    }, [site, t, openingHours])

    const {phoneNumbersToForwardTo} = usePhoneNumbersToForwardTo(site)

    useEffect(() => {
        setValue(`fieldUpdates.1.fieldName`, 'forwardNumber')
    }, [setValue]);

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('schedules.schedule')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={false}
                autoCompleteOptions={scheduleOptions}
            />
        </FormFieldBox>
        <FormFieldBox>
            <ForwardToNumberField phoneNumbersToForwardTo={phoneNumbersToForwardTo}
                                  defaultNumber={''}
                                  readonly={false} required={true}
                                  label={t('time-based-forwarding.forwarding-number')} name={`fieldUpdates.${index+1}.values.0.stringValue`} control={control} />
        </FormFieldBox>
    </FormRow>)
}